import React from 'react';

//import Spinner from 'react-spinner';
//import TransitionGroup from 'react-transition-group/CSSTransitionGroup';
//
import SourceBox from '../SourceBox';

import fetchContent from '../../helpers/backend-communication';
import { parseUnrocaData } from '../../helpers/parse-unroca-data';
import { slugify } from '../../helpers/format';
import UNROCACountryNames from '../../helpers/UNROCACountryNames';

const smallArmsColumns = [
  {key: 'typeOfWeaponVerbose', label: 'Small Arms'},
  {key: 'amountReportedByCountry', label: '*'},
  {key: 'amountReportedByOthers', label: '**'}
];

const lightWeaponsColumns = [
  {key: 'typeOfWeaponVerbose', label: 'Light Weapons'},
  {key: 'amountReportedByCountry', label: '*'},
  {key: 'amountReportedByOthers', label: '**'}
];

class UNROCADatabase extends React.Component{
  constructor(props) {
    super(props);

    this.state =  {
      unrocaData: null
    };
  }

  componentDidMount() {
    const countryName = slugify(this.props.countryName);

    console.log("Fetching content for UNROCA Sourcebox....");

    fetchContent('unroca', `${UNROCACountryNames[countryName] || countryName}`)
      .then( responseObject => {
        const unrocaData = parseUnrocaData(responseObject);
        this.setState({ unrocaData: unrocaData });
      })
      .catch( error => {
        console.error("Fetch went wrong", error);
      });
  }

  getTopic(topicSet, topicName) {
    const topic = topicSet.find(
      (item) => item.topicName === topicName
    )
    return topic && topic.topicData;
  }

  buildSections() {
    const datasets = this.state.unrocaData.datasets,
      sectionImport = { title: 'Import', tables: []},
      sectionExport = { title: 'Export', tables: []};

    const smallArmsImports = this.getTopic(datasets, "Small Arms Imports");
    const lightWeaponsImports = this.getTopic(datasets, "Light Weapons Imports");
    const smallArmsExports = this.getTopic(datasets, "Small Arms Exports");
    const lightWeaponsExports = this.getTopic(datasets, "Light Weapons Exports");

    sectionImport.tables.push({
      columns: smallArmsColumns,
      data: smallArmsImports
    });

    sectionImport.tables.push({
      columns: lightWeaponsColumns,
      data: lightWeaponsImports
    });

    sectionExport.tables.push({
      columns: smallArmsColumns,
      data: smallArmsExports
    });

    sectionExport.tables.push({
      columns: lightWeaponsColumns,
      data: lightWeaponsExports
    });

    return [sectionImport, sectionExport];
  }

  render() {
    const {unrocaData} = this.state;

    if (!unrocaData) { return null; }
    //const dataTables = unrocaData.map((el, i) => <p key={i}>JSON.stringify(el)</p> );
    //
    //{ unrocaData == null || unrocaData.length<1 ?
      //<Spinner/> :
      //<TransitionGroup
          //transitionName="ajax"
          //transitionEnterTimeout={500}
          //transitionLeaveTimeout={300}>
          //{ dataTables }
      //</TransitionGroup>
    //}


    const legend = (
      <p>
        <strong>*</strong>
        <small>What the country reported</small>
        <br></br>
        <strong>**</strong>
        <small>What the country's trading partner reported</small>
      </p>
    );

    const title = (
      <span>
        United Nations Register of Conventional Arms<br></br>(UNROCA)
      </span>
    );

    return (
      <SourceBox
        title={ title }
        info='States submit information on import and export of small arms and light weapons to UNROCA. Data submitted by this country can be compared with data from its trading partners.'
        logoClass='background-logo-un'
        description={ 'Source of data: National reports submitted to UNROCA in the year ' + unrocaData.year }
        legend={ legend }
        sections={ this.buildSections() }
      />
    );
  }
}

export default UNROCADatabase



// WEBPACK FOOTER //
// ./src/components/RelatedDatabases/UNROCADatabase.js